/* global axios */
import ApiClient from '../ApiClient';

class WuzapiInstance extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/wuzapi_instance`);
  }
}

export default new WuzapiInstance();
